import React from "react";
import { Link } from "react-router-dom";
import { PROFILE_IMAGE_BASE } from "../../config/env";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HeaderTopUserBlock = (props) => {
  const { userDetails } = props;
  const loggedinUserDetails = JSON.parse(userDetails);
  const profileName = `${loggedinUserDetails.first_name} ${loggedinUserDetails.last_name}`;
  return (
    <Link to={"dashboard"}>
      <div className="d-flex align-items-center">
        <button className="btn btn-outline-light btn-sm">
          <FontAwesomeIcon icon={faUser} /> Profile
        </button>
      </div>
    </Link>
  );
};

export default HeaderTopUserBlock;
